class SearchBar {
	constructor(searchBarSelector) {
		this.searchBar = document.querySelector(searchBarSelector);
		this.input = this.searchBar.querySelector('[data-search-bar-input]');
		this.resetBtn = this.searchBar.querySelector('[data-search-bar-reset]');

		this.resetBtn.addEventListener('click', () => this.reset());
		this.input.addEventListener('input', () => this.onInput());
	}

	reset() {
		this.input.value = '';
		this.onInput();
		this.input.focus();
	}

	onInput() {
		if (this.input.value.length > 0) {
			this.searchBar.classList.add('search-bar--is-populated');
		} else {
			this.searchBar.classList.remove('search-bar--is-populated');
		}
	}
}

export default SearchBar;
